export default {
  sent(state) {
    return state.sent;
  },
};
